import React from "react";
import { noDealsvg } from "../../DealsAndDiscounts/Components/ProductListing/svg";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
var ZeroState = function ZeroState(_ref) {
  var type = _ref.type,
    propMessage = _ref.message;
  var content = {
    deals: {
      title: "Oops!",
      message: "No deals found.",
      subMessage: "We are busy curating exciting offers for you. Stay tuned.",
      icon: noDealsvg
    },
    events: {
      title: "Sorry!",
      message: "No images or videos are present for this event.",
      subMessage: "We will update soon.",
      icon: noDealsvg
    },
    blogs: {
      title: "Sorry!",
      message: "No blogs found.",
      subMessage: "We are busy curating exciting content for you. Stay tuned.",
      icon: noDealsvg
    },
    contest: {
      title: "Sorry!",
      message: "No past contests found.",
      subMessage: "We are busy curating exciting contests for you. Stay tuned.",
      icon: noDealsvg
    }
  };
  var defaultContent = content[type] || {};
  var message = propMessage || content[type].message;
  return /*#__PURE__*/_jsx("div", {
    className: "mt-4 px-4 lg:px-0",
    children: /*#__PURE__*/_jsx("div", {
      className: "w-full pl-0 xl:pl-6 mt-4 border border-gray-300 rounded-xl",
      children: /*#__PURE__*/_jsxs("div", {
        className: "flex flex-row items-center justify-center p-5 lg:p-7 gap-5",
        children: [/*#__PURE__*/_jsx("div", {
          className: "mt-1 lg:mt-0",
          children: defaultContent.icon
        }), /*#__PURE__*/_jsxs("div", {
          className: "flex flex-col",
          children: [/*#__PURE__*/_jsx("p", {
            className: "text-lg lg:text-2xl font-bold",
            children: defaultContent.title
          }), /*#__PURE__*/_jsx("p", {
            className: "text-sm lg:text-base whitespace-nowrap mt-2",
            children: message
          }), /*#__PURE__*/_jsx("p", {
            className: "lg:whitespace-nowrap mt-1 text-gray-400",
            children: defaultContent.subMessage
          })]
        })]
      })
    })
  });
};
export default ZeroState;